import { render } from "./ImagesSyntheticsBis.vue?vue&type=template&id=28642a66"
import script from "./ImagesSyntheticsBis.vue?vue&type=script&lang=js"
export * from "./ImagesSyntheticsBis.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__